import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  Button,
  Grid,
  TextField,
  MenuItem,
  CircularProgress,
  Card,
  CardHeader,
  CardContent,
  Divider,
  Typography,
  IconButton,
  Avatar,
  FormControl,
  InputLabel,
  Paper,
  Box
} from '@mui/material';
import {
  ArrowBack as ArrowBackIcon,
  Business as BusinessIcon,
  Save as SaveIcon
} from '@mui/icons-material';
import axios from 'axios';
import Swal from 'sweetalert2';
import { SwalConfig } from '../../utils/swalConfig';

const EditVendor = () => {
  const { id } = useParams();
  console.log('ID Vendor:', id);
  console.log('Fetching vendor with ID:', id);

  const [vendorData, setVendorData] = useState({
    _id: '',
    vendor_name: '',
    pic_title: '',
    pic_last_name: '',
    pic_position: '',
    payment_address: '',
    address: '',
    id_city: '',
    id_province: '',
    id_country: '',
    phone: '',
    fax: '',
    mobile: '',
    email: '',
    business_type: '',
    term_of_payment: '',
    id_bu: '',
    tax_no: '',
    bank_account_name: '',
    bank_account_number: '',
    bank_account_nameholder: '',
    bank_account_brench: '',
    internal_pic: '',
    is_active: 1,
  });

  const [buList, setBuList] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Fetching business units
    const fetchBusinessUnits = async () => {
      try {
        const response = await fetch('https://apidashboard.eurekagroup.id/bu');
        const businessUnits = await response.json();
        setBuList(businessUnits);
      } catch (error) {
        console.error('Error fetching business units:', error);
      }
    };

    // Fetching vendor data
    const fetchVendorData = async () => {
      try {
        const response = await fetch(`https://apidashboard.eurekagroup.id/vendor/get/${id}`);
        const data = await response.json();
        if (data) {
          setVendorData({
            ...data,
            date_added: data.date_added ? data.date_added.split('T')[0] : '',
            date_modified: data.date_modified ? data.date_modified.split('T')[0] : '',
            id_bu: data.id_bu ? data.id_bu._id : '',
          });
        }
      } catch (error) {
        console.error('Error fetching vendor data:', error);
      }
    };

    fetchBusinessUnits();
    fetchVendorData();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setVendorData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    const currentDate = new Date().toISOString();
  
    // Prepare the data object
    const updatedVendorData = {
      id: vendorData._id,
      vendor_name: vendorData.vendor_name || "",
      pic_title: vendorData.pic_title || "",
      pic_last_name: vendorData.pic_last_name || "",
      pic_position: vendorData.pic_position || "",
      payment_address: vendorData.payment_address || "",
      address: vendorData.address || "",
      id_city: vendorData.id_city || "",
      id_province: vendorData.id_province || "",
      id_country: vendorData.id_country || "",
      phone: vendorData.phone || "",
      fax: vendorData.fax || "",
      mobile: vendorData.mobile || "",
      email: vendorData.email || "",
      business_type: vendorData.business_type || "",
      term_of_payment: vendorData.term_of_payment || "",
      id_bu: vendorData.id_bu || "",
      tax_no: vendorData.tax_no || "",
      bank_account_name: vendorData.bank_account_name || "",
      bank_account_number: vendorData.bank_account_number || "",
      bank_account_nameholder: vendorData.bank_account_nameholder || "",
      bank_account_brench: vendorData.bank_account_brench || "",
      internal_pic: vendorData.internal_pic || "",
      is_active: vendorData.is_active || 1,
      date_added: currentDate,
      date_modified: currentDate,
    };
  
    const token = localStorage.getItem('token'); // Retrieve the token from localStorage
  
    try {
      // Make the PUT request with JSON payload and Authorization header
      await axios.put(
        `https://apidashboard.eurekagroup.id/vendor/edit`,
        updatedVendorData,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`, // Add Authorization header with Bearer token
          },
        }
      );
  
      setLoading(false);
      SwalConfig.success(
        'Berhasil!',
        'Data vendor berhasil diperbarui! Perubahan telah tersimpan dalam sistem.',
        2000
      );
      navigate('/kontak/vendor');  // Redirect after successful update
    } catch (error) {
      console.error('Error updating vendor data:', error);
      setLoading(false);
      SwalConfig.error(
        'Gagal!',
        'Gagal memperbarui vendor! Silakan coba lagi atau hubungi administrator.'
      );
    }
  };  

  return (
    <div className="animate-fade-in">
      {/* Header */}
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
        <IconButton 
          onClick={() => navigate('/kontak/vendor')}
          sx={{ 
            bgcolor: 'primary.main',
            color: 'white',
            '&:hover': { 
              bgcolor: 'primary.dark',
              transform: 'translateY(-2px)'
            },
            transition: 'all 0.3s ease',
            mr: 2
          }}
        >
          <ArrowBackIcon />
        </IconButton>
        <Box>
          <Typography variant="h4" sx={{ fontWeight: 600, color: 'text.primary' }} className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
            ✏️ Edit Vendor
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5 }}>
            Perbarui informasi vendor sesuai kebutuhan
          </Typography>
        </Box>
      </Box>

      {/* Form Content */}
      <Card sx={{ boxShadow: '0 8px 32px rgba(0,0,0,0.1)', borderRadius: 3 }}>
        <CardHeader 
          title={
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Avatar sx={{ bgcolor: 'primary.main', width: 40, height: 40 }}>
                <BusinessIcon />
              </Avatar>
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                Form Edit Vendor
              </Typography>
            </Box>
          }
        />
        <Divider />
        <CardContent sx={{ p: 4 }}>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <TextField
                  required
                  fullWidth
                  label="Nama Vendor"
                  name="vendor_name"
                  value={vendorData.vendor_name}
                  onChange={handleChange}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="PIC Title"
                  name="pic_title"
                  value={vendorData.pic_title}
                  onChange={handleChange}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="PIC Last Name"
                  name="pic_last_name"
                  value={vendorData.pic_last_name}
                  onChange={handleChange}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="PIC Position"
                  name="pic_position"
                  value={vendorData.pic_position}
                  onChange={handleChange}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Payment Address"
                  name="payment_address"
                  value={vendorData.payment_address}
                  onChange={handleChange}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Internal PIC"
                  name="internal_pic"
                  value={vendorData.internal_pic}
                  onChange={handleChange}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Address"
                  name="address"
                  value={vendorData.address}
                  onChange={handleChange}
                  variant="outlined"
                  multiline
                  rows={3}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  label="City ID"
                  name="id_city"
                  value={vendorData.id_city}
                  onChange={handleChange}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  label="Province ID"
                  name="id_province"
                  value={vendorData.id_province}
                  onChange={handleChange}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  label="Country ID"
                  name="id_country"
                  value={vendorData.id_country}
                  onChange={handleChange}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Phone"
                  name="phone"
                  value={vendorData.phone}
                  onChange={handleChange}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Fax"
                  name="fax"
                  value={vendorData.fax}
                  onChange={handleChange}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Mobile"
                  name="mobile"
                  value={vendorData.mobile}
                  onChange={handleChange}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Email"
                  name="email"
                  value={vendorData.email}
                  onChange={handleChange}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Business Type"
                  name="business_type"
                  value={vendorData.business_type}
                  onChange={handleChange}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Term of Payment"
                  name="term_of_payment"
                  value={vendorData.term_of_payment}
                  onChange={handleChange}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  select
                  fullWidth
                  label="Business Unit"
                  name="id_bu"
                  value={vendorData.id_bu}
                  onChange={handleChange}
                  variant="outlined"
                >
                  {buList.map((bu) => (
                    <MenuItem key={bu._id} value={bu._id}>
                      {bu.bu_name}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Tax No"
                  name="tax_no"
                  value={vendorData.tax_no}
                  onChange={handleChange}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Bank Account Name"
                  name="bank_account_name"
                  value={vendorData.bank_account_name}
                  onChange={handleChange}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Bank Account Number"
                  name="bank_account_number"
                  value={vendorData.bank_account_number}
                  onChange={handleChange}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Bank Account Nameholder"
                  name="bank_account_nameholder"
                  value={vendorData.bank_account_nameholder}
                  onChange={handleChange}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Bank Account Branch"
                  name="bank_account_brench"
                  value={vendorData.bank_account_brench}
                  onChange={handleChange}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  select
                  fullWidth
                  label="Status"
                  name="is_active"
                  value={vendorData.is_active}
                  onChange={handleChange}
                  variant="outlined"
                >
                  <MenuItem value={1}>Active</MenuItem>
                  <MenuItem value={0}>Inactive</MenuItem>
                </TextField>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </Card>

      {/* Action Buttons */}
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 3 }}>
        <Button
          variant="outlined"
          onClick={() => navigate('/kontak/vendor')}
          sx={{ 
            borderRadius: 2,
            px: 3,
            py: 1.5,
            textTransform: 'none',
            fontWeight: 600
          }}
        >
          ❌ Batal
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={loading}
          className="bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700"
          sx={{ 
            borderRadius: 2,
            px: 4,
            py: 1.5,
            textTransform: 'none',
            fontWeight: 600,
            '&:hover': {
              transform: 'translateY(-2px)'
            }
          }}
          startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <SaveIcon />}
        >
          {loading ? 'Menyimpan...' : '💾 Simpan Perubahan'}
        </Button>
      </Box>
    </div>
  );
};

export default EditVendor;
